import { render, staticRenderFns } from "./HistoricoCargaPatrimonialItensList.vue?vue&type=template&id=737fd63a"
import script from "./HistoricoCargaPatrimonialItensList.vue?vue&type=script&lang=js"
export * from "./HistoricoCargaPatrimonialItensList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports